import { SHOW_NOTIFICATION, CLEAR_NOTIFICATION } from 'actions/Types';

export default (state = [], action) => {
  if (action.type === SHOW_NOTIFICATION) {
    return [...state, action.payload];
  }

  if (action.type === CLEAR_NOTIFICATION) {
    return state.filter(item => item.message !== action.payload.message);
  }

  return state;
};
